<nwx-uw-reports-card
  [model]="(viewModel$ | async) || defaultViewModel"
  (clickReportLink)="onClickReportLink($event)"
  (refresh)="onRefresh()"
></nwx-uw-reports-card>
